// Module
var code = "<template>\n  <require from=\"./equipment-type-form\"></require>\n  <view-header>\n    <span slot=\"title\" t=\"equipmenttype.new\"></span>\n  </view-header>\n  <main>\n    <form>\n      <equipment-type-form if.bind=\"equipmenttype\" equipmenttype.two-way=\"equipmenttype\"></equipment-type-form>      \n    </form>\n  </main>\n</template>\n";
// Exports
export default code;